<template>
    <div>
        <div class="image">
            IMAGE
        </div>
        <div>
            <div class="price">
                $900 - $1700
            </div>
            <div class="name">
                Peloquin Heights
            </div>
            <div class="rooms">
                2 bed | 2 bath
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            imgSrc: {
                type: String,
                required: false,
                default: () => 123,
            },
            price: {
                type: String,
                required: false,
            },
            name: {
                type: String,
                required: false,
            },
            rooms: {
                type: String,
                // required: true,
            },
        },
        data() {
            return {
                abc: 13,
            };
        },
    };
</script>
<style
        lang="scss"
        scoped
>
    @import '~bootstrap/scss/functions';
    @import "../scss/_variables.scss";

    .image {
        max-width:  160px;
        max-height: 100px;
    }

    .price {
        color:       $white;
        font-family: Catamaran;
        font-size:   $font-size-base;
        font-weight: $font-weight-bold;
        text-align:  center;
    }

    .name {
        font-size:   $font-size-sm;
        font-family: Roboto;
        text-align:  center;
        color:       darken($primary, .3);
    }

    .rooms {
        color:       $white;
        font-family: Roboto;
        font-size:   $font-size-sm;
        text-align:  center;
    }
</style>
